import { FieldType } from 'modules/domains';

export const isBooleanFieldType = (type?: FieldType): type is FieldType.BOOLEAN =>
  type === FieldType.BOOLEAN;
